import { useQuery } from '@tanstack/react-query'
import { api, queryKeys } from '@/lib/api'
import type { Team } from '@/types'

interface UseAllTeamsOptions {
  enabled?: boolean
}

export function useAllTeams(options: UseAllTeamsOptions = {}): {
  teams: Team[]
  isLoading: boolean
  isFetching: boolean
  error: Error | null
  refetch: () => Promise<any>
} {
  const { enabled = true } = options

  const queryResult = useQuery({
    queryKey: queryKeys.admin.teams.list(),
    enabled,
    queryFn: async () => {
      const response = await api.teams.list()

      if (!response.success) {
        throw new Error(response.error || 'Failed to load teams')
      }

      if (!Array.isArray(response.data)) {
        return []
      }

      return response.data.filter((team): team is Team => Boolean(team))
    },
  })

  return {
    teams: queryResult.data ?? [],
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    error: (queryResult.error as Error) ?? null,
    refetch: queryResult.refetch,
  }
}
